export const FAIRLEAD_LABEL = 'Fairleads'
export const WINCH_LABEL = 'Winches'
export const PEDESTAL_LABEL = 'Pedestals'
export const TAULINE_LABEL = 'Mooring lines'

export const MOORING_POINT_LABEL = 'Mooring points'
